<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <span>Edição de arquivo automática</span>
                        <h1>Arquivos do Ms word editados em minutos</h1>
                        <p>Economize tempo com edições automáticas em seus documentos do MS Word. Baixe seu arquivo editado
                            com as alterações de faixa e finalize seu documento super rápido!</p>
                        <a href="https://cloud.trinka.ai/signup?_rg=PT" id="autoEditGetStart" target="_blank">Iniciar</a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/AutoEditBanner.jpg" alt="auto edit">
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <div class="SectionHowItWrok">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="ImgSectionHowItWrok">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src=".././../../assets/images/AutoFileEditThumbnail.png" alt="auto edit thumbnail" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-xl-6">
                    <div class="contentSectionHowItWrok">
                        <h2>Veja como funciona</h2>
                        <div class="HeadingSubLine"></div>
                        <p style="margin-bottom: 10px;">Confira o vídeo passo a passo fácil para começar com a edição automática de arquivos rapidamente.</p>
                        <p style="margin-bottom: 10px;">É um tutorial passo a passo detalhado para ajudá-lo a usar Trinka ao máximo. Tem mais perguntas?
                            Navegue pelas nossas perguntas frequentes
                            <a style="color: #0000ff;" (click)="scroll(target)" class="link">aqui</a>.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Principais características da Trinka auto-Edit</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Evite o incômodo de instalar plug-ins. Corrija seu arquivo do MS Word usando o recurso Auto File
                            Edit. A Trinka edita automaticamente seu documento em mudanças de faixa, que você pode baixar
                            e finalizar.</p>
                    </div>
                </div>
            </div>
            <div class="row">

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="download track changes">
                        <h3>Baixar o arquivo de alterações de rastreamento</h3>
                        <p>Baixe e finalize um arquivo de alterações de faixa mostrando as várias alterações selecionadas no
                            editor Trinka.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/RetainOriginalFormatting.png" alt="formatting">
                        <h3>Manter a formatação original</h3>
                        <p>Seu conteúdo será atualizado com todas as alterações feitas conforme as alterações de faixa, garantindo
                            que a formatação original seja sempre mantida.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/languageScore_icon.svg" alt="language score">
                        <h3>Pontuação de idioma</h3>
                        <p>Obtenha uma pontuação indicativa da qualidade geral do idioma do documento com base no número de
                            revisões por categoria.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/TableofRevisions_icon.svg" alt="table revisions">
                        <h3>Tabela de revisões</h3>
                        <p>Veja uma tabela detalhada de revisões por categoria de idioma para uma compreensão rápida do tipo
                            de edições feitas.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style guid">
                        <h3>Preferências do guia de estilo</h3>
                        <p>Personalize a gramática e a escolha da palavra do seu manuscrito para cumprir os guias de estilo
                            acadêmico populares (AMA 11th, AGU 2017).</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area">
                        <h3>Área de assunto e tipo de documento</h3>
                        <p>Personalize a Trinka para fornecer as sugestões mais relevantes com base na sua área de assunto e
                            no tipo de manuscrito.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="uploadOptionSection">
        <div class="container">
            <div class="uploadContentSection">
                <h2>Importe arquivos do seu armazenamento em nuvem favorito e edite-os em minutos!</h2>
                <ul>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="44" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.6349 15.109C21.6349 15.3108 21.5751 15.5081 21.4629 15.676C21.3508 15.8438 21.1914 15.9746 21.0049 16.0518C20.8184 16.1291 20.6132 16.1493 20.4152 16.1099C20.2173 16.0705 20.0354 15.9733 19.8927 15.8306C19.7499 15.6879 19.6527 15.506 19.6134 15.3081C19.574 15.1101 19.5942 14.9049 19.6714 14.7184C19.7487 14.5319 19.8795 14.3725 20.0473 14.2604C20.2152 14.1482 20.4125 14.0884 20.6143 14.0884C20.885 14.0884 21.1446 14.1959 21.336 14.3873C21.5274 14.5787 21.6349 14.8383 21.6349 15.109V15.109Z" fill="#773795"/>
                                <path d="M24.9945 10.7444C24.9945 10.5326 25.3093 11.3578 21.1944 1.46144C21.1374 1.32431 21.0409 1.20723 20.9172 1.12507C20.7934 1.04291 20.6481 0.999383 20.4996 1.00001H6.24404C6.10455 0.999291 5.96763 1.03753 5.8487 1.11042C5.72977 1.18332 5.63356 1.28796 5.57089 1.41258C0.685141 11.1841 1.02171 10.4729 1 10.6412C1 10.7118 1 10.1961 1 18.2413C1 18.3397 1.01938 18.4371 1.05703 18.528C1.09467 18.6188 1.14986 18.7014 1.21942 18.771C1.28899 18.8406 1.37157 18.8957 1.46246 18.9334C1.55335 18.971 1.65077 18.9904 1.74915 18.9904H24.2453C24.4421 18.9904 24.631 18.913 24.7712 18.7748C24.9114 18.6367 24.9916 18.4489 24.9945 18.2521C24.9945 18.1273 24.9945 10.7986 24.9945 10.7444V10.7444ZM24.9945 10.6901H1.02171H24.9945Z" stroke="#4D4D4D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>Trinka My Drive</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="52" height="46" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.25 0C3.65326 0 3.08097 0.237053 2.65901 0.65901C2.23705 1.08097 2 1.65326 2 2.25V11.25C2 11.8467 2.23705 12.419 2.65901 12.841C3.08097 13.2629 3.65326 13.5 4.25 13.5H19.75C20.3467 13.5 20.919 13.2629 21.341 12.841C21.7629 12.419 22 11.8467 22 11.25V2.25C22 1.65326 21.7629 1.08097 21.341 0.65901C20.919 0.237053 20.3467 0 19.75 0H4.25ZM3.5 2.25C3.5 2.05109 3.57902 1.86032 3.71967 1.71967C3.86032 1.57902 4.05109 1.5 4.25 1.5H19.75C19.9489 1.5 20.1397 1.57902 20.2803 1.71967C20.421 1.86032 20.5 2.05109 20.5 2.25V11.25C20.5 11.4489 20.421 11.6397 20.2803 11.7803C20.1397 11.921 19.9489 12 19.75 12H4.25C4.05109 12 3.86032 11.921 3.71967 11.7803C3.57902 11.6397 3.5 11.4489 3.5 11.25V2.25ZM0.75 14.5C0.551088 14.5 0.360322 14.579 0.21967 14.7197C0.0790175 14.8603 0 15.0511 0 15.25C0 15.4489 0.0790175 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H23.25C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25C24 15.0511 23.921 14.8603 23.7803 14.7197C23.6397 14.579 23.4489 14.5 23.25 14.5H0.75Z" fill="#4D4D4D"/>
                                <path d="M10 6H14" stroke="#773795" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <p>My Device</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="51" height="47" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8871)">
                                <path d="M5.99953 0L0 3.82228L5.99953 7.64466L12 3.82228L5.99953 0ZM18 0L12 3.82266L18 7.64531L24.0001 3.82266L18 0ZM0 11.4676L5.99953 15.29L12 11.4676L5.99953 7.64531L0 11.4676ZM18 7.64531L12 11.468L18 15.2905L24 11.468L18 7.64531ZM6 16.5723L12.0005 20.3947L18 16.5723L12.0005 12.75L6 16.5723Z" fill="#0061FF"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8871">
                                <rect width="24" height="20.4375" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >DropBox</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="46" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.81444 18.3783L2.87287 20.2064C3.09281 20.5914 3.40894 20.8938 3.78009 21.1137C4.84322 19.7643 5.58309 18.7287 6.00009 18.0071C6.42319 17.2749 6.94322 16.1293 7.56019 14.5707C5.89744 14.3518 4.63744 14.2424 3.78019 14.2424C2.95734 14.2424 1.69734 14.3518 0 14.5707C0 14.9968 0.109969 15.4229 0.329906 15.8079L1.81444 18.3783V18.3783Z" fill="#0066DA"/>
                                <path d="M20.2204 21.1137C20.5917 20.8938 20.9078 20.5914 21.1276 20.2065L21.5675 19.4505L23.6707 15.8079C23.8866 15.4313 24.0003 15.0048 24.0005 14.5707C22.2933 14.3518 21.0357 14.2424 20.2274 14.2424C19.3587 14.2424 18.1009 14.3518 16.4541 14.5707C17.0638 16.1379 17.5769 17.2834 17.9937 18.0071C18.4139 18.7374 19.1562 19.7728 20.2204 21.1137V21.1137Z" fill="#EA4335"/>
                                <path d="M11.9998 6.87291C13.2298 5.38744 14.0775 4.24191 14.5428 3.4365C14.9175 2.78794 15.3299 1.75238 15.7799 0.329906C15.4088 0.109969 14.9827 0 14.5428 0H9.45685C9.01698 0 8.59098 0.12375 8.21973 0.329906C8.79216 1.96134 9.27798 3.12244 9.67698 3.81309C10.118 4.57641 10.8923 5.59631 11.9998 6.87291Z" fill="#00832D"/>
                                <path d="M16.4401 14.5706H7.56028L3.78027 21.1136C4.15134 21.3335 4.57743 21.4435 5.01731 21.4435H18.9831C19.4229 21.4435 19.8491 21.3197 20.2202 21.1135L16.4402 14.5706H16.4401Z" fill="#2684FC"/>
                                <path d="M12.0001 6.87298L8.22009 0.330078C7.84884 0.550016 7.53272 0.852359 7.31278 1.2373L0.329906 13.3336C0.114012 13.7102 0.000285232 14.1366 0 14.5707H7.56019L12.0002 6.87298H12.0001Z" fill="#00AC47"/>
                                <path d="M20.1788 7.28524L16.6872 1.23705C16.4674 0.852115 16.1512 0.549772 15.78 0.329834L12 6.87284L16.4398 14.5706H23.9863C23.9863 14.1444 23.8763 13.7184 23.6564 13.3334L20.1788 7.28524Z" fill="#FFBA00"/>
                            </svg>
                        </div>
                        <p >Google Drive</p>
                    </li>
                    <li>
                        <div class="uploadFileIcon">
                            <svg width="50" height="42" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1393_8873)">
                                <path d="M14.4991 10.3764L19.453 5.63883C18.424 1.62633 14.3371 -0.792141 10.3246 0.236954C8.51775 0.700347 6.9484 1.8204 5.92285 3.37852C5.99945 3.37664 14.4991 10.3764 14.4991 10.3764V10.3764Z" fill="#0364B8"/>
                                <path d="M9.15169 4.27053L9.1515 4.27137C8.20489 3.68508 7.11319 3.37519 5.99972 3.37671C5.97403 3.37671 5.94872 3.37831 5.92303 3.37859C2.61113 3.41965 -0.0405003 6.13784 0.000468414 9.44985C0.0153465 10.6512 0.390719 11.8204 1.07794 12.8059L8.49966 11.8764L14.1897 7.28825L9.15169 4.27053V4.27053Z" fill="#0078D4"/>
                                <path d="M19.4529 5.63899C19.3434 5.63124 19.2337 5.62714 19.1239 5.62671C18.4593 5.62607 17.8017 5.7618 17.1917 6.02552L17.1915 6.02506L14.1895 7.28834L17.499 11.3765L23.4156 12.8147C24.6924 10.4444 23.8059 7.48784 21.4356 6.21096C20.8231 5.88105 20.1471 5.68606 19.4529 5.63909V5.63899Z" fill="#1490DF"/>
                                <path d="M1.07812 12.8058C1.63023 13.5996 2.36625 14.248 3.22333 14.6956C4.08041 15.1432 5.03308 15.3767 6 15.3762H19.1244C20.0044 15.3764 20.868 15.1384 21.6236 14.6874C22.3792 14.2364 22.9987 13.5893 23.4161 12.8146L14.1899 7.28809L1.07812 12.8058V12.8058Z" fill="#28A8EA"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1393_8873">
                                <rect width="24" height="15.4688" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <p >OneDrive</p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="cloud_key_features" style="padding: 0;margin: 0 0 60px 0;">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="key_features_heading">
                        <h2>Ver um exemplo de relatório</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-10">
                    <div class="viewSampleReportImg">
                        <a href="../../../assets/resources/AutoEdit_sample_edited.docx" target="_blank">Ver o Relatório na Íntegra
                            <i class="fa fa-arrows-alt" aria-hidden="true"></i>
                        </a>
                        <img src="../../../assets/images/revised-menuscript.png" alt="revised script">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="use_trinka_other_app accomplishBrilliantWrap">
        <div class="container">
            <div class="accomplishBrilliantSection">
                <h2>Obtenha seus arquivos do word editados automaticamente</h2>
                <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Iniciar</a>
            </div>
        </div>
    </div>

    <div class="allAboutTrinkaCredit">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="aboutTrinkaCreditHeading">
                        <h2>A edição de arquivos automática usa créditos</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                    <div class="creditSectionFeature">
                        <div class="featurePointsCredits">
                            <span>
                                <img src="../../../assets/images/lightbulb.png" alt="icon">
                            </span>
                            <p>Usa 1 crédito para cada 5.000 palavras em um arquivo. Use créditos gratuitos e compre mais conforme
                                necessário.
                            </p>
                        </div>
                        <div class="othersPointsForCredits">
                            <p style="margin-bottom: 10px;">Os créditos são como tokens que permitem que você use vários recursos do Trinka conforme necessário.
                                Usuários Premium ganham 10 e usuários Básicos ganham 4 créditos grátis todo mês. Para saber
                                mais clique <a [routerLink]="['/features/credits']">aqui</a>.</p>
                        </div>
                    </div>
                </div>

                <!-- <div class="col-lg-4 col-md-6">
                        <div class="CreditBoxTrinka">
                            <div class="card_overlay"></div>
                            <div class="CreditBoxTrinkaHeader">
                                <h3>Free Credits Available</h3>
                            </div>
                            <p>Basic users get 2 and Premium users get 5 free credits every month. Unused free credits expire at month end.</p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="CreditBoxTrinka">
                            <div class="card_overlay"></div>
                            <div class="CreditBoxTrinkaHeader">
                                <h3>Credits Consumed</h3>
                            </div>
                            <p>Auto File Edit uses 1 credit for every 5000 words. You may upload larger files; credits required will be shown and consumed accordingly. </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <div class="CreditBoxTrinka">
                            <div class="card_overlay"></div>
                            <div class="CreditBoxTrinkaHeader">
                                <h3>Buy More Credits</h3>
                            </div>
                            <p>If you need additional credits, you can purchase them whenever needed. Purchased Credits do not expire.</p>
                        </div>
                    </div> -->
            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>Perguntas feitas frequentemente</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        O que você obtém ao fazer upload do arquivo para Edição Automática do Arquivo?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <h4>Você obtém o seguinte ao fazer upload do arquivo para edição automática: </h4>
                                        <ol>
                                            <li>O arquivo editado com todas as mudanças na faixa altera. Você pode revisar essas
                                                alterações e aceitar ou rejeitar usando o Microsoft Word ou qualquer outro
                                                processador de texto compatível. Este arquivo também incluirá comentários
                                                explicando as correções.</li>
                                            <li> Você também receberá um relatório detalhado que incorpora o número de revisões,
                                                tipos de erros gramaticais cometidos e uma pontuação geral de qualidade da
                                                redação.
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">
                                        Posso fazer upload em massa de vários documentos ao mesmo tempo? Existe um limite? </a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Você pode fazer upload de quantos documentos quiser para serem editados automaticamente.
                                            Não há limitação quanto ao número de documentos que podem ser carregados. Apenas
                                            1 crédito é usado para cada 5.000 palavras em seu(s) arquivo(s).</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Como eu mesmo experimento o recurso Auto File Edit (Edição Automática de Arquivo)?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Basta se inscrever no Trinka. Você encontrará a oção Auto Edit File à esquerda no
                                            painel de navegação. Carregue um documento e clique em iniciar a edição. Voilà!
                                            Obtenha o seu documento editado automaticamente em minutos!</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Quantos créditos são consumidos ao usar o Auto File Edit?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <!-- <p>In addition to all the features you get in Basic, you also get Power Mode with a Premium subscription.  Power Mode provides users with up to 40% more suggestions for their content while considering the context of the writing. Furthermore, </p> -->
                                        <p>Os usuários básicos recebem 4 créditos gratuitos todos os meses, enquanto os usuários
                                            Premium recebem 10 créditos gratuitos todos os meses. O Auto File Edit usa 1 crédito
                                            para cada 5.000 palavras em seu arquivo. </p>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        Correção Gramatical Automática para o seu arquivo MS Word com Trinka
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">

                                        <p>Trinka edita automaticamente o seu documento do MS Word para correções gramaticais
                                            e ortográficas. Faça o download com alterações controladas e evite o incômodo
                                            de instalações do plug-in. </p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/pt/trinkacloud">
                                        <div class="app_name_content" routerLink="/trinkacloud">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                            <h3>Trinka Cloud</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/wordplugin">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word Plug-in</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/browser-plugin">
                                        <div class="app_name_content" routerLink="/browser-plugin">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                            <h3>Plugins do navegador</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/pt/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                            <span style="font-size: 12px; color: #000; position: relative;">(API, JS & On-Premise)
                                            </span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>